import { defineComponent as _defineComponent } from 'vue'
import NavigationBar from "@/components/shared/NavigationBar.vue";
import Page from "@/components/shared/Page.vue";
import { useRoute } from "vue-router";
import { ref, computed, onMounted } from "vue";
import { useServiceStore } from "@/stores/serviceStore";


const __default__ = {
  name: "Chat",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const route = useRoute();
const parseComplete = ref(false);
const serviceStore = useServiceStore();

const twcConfig = computed(() => serviceStore.serviceInfo?.twcConfig);

const loginId = ref("");
const name = ref("");
const email = ref("");
const phone = ref("");
const chatUrl = computed(
  () =>
    `https://webchat.thecloudgate.io/webChat?brandKey=${encodeURIComponent(
      twcConfig.value?.brandKey ?? ""
    )}&channelType=${
      twcConfig.value?.channelType ?? "scenario"
    }&scenarioId=${encodeURIComponent(
      twcConfig.value?.scenarioId ?? ""
    )}&loginId=${encodeURIComponent(loginId.value)}&name=${encodeURIComponent(
      name.value
    )}&phone=${encodeURIComponent(phone.value)}`
);

const parseLoginId = () => {
  loginId.value = route.query?.loginId?.toString() ?? "";
  name.value = route.query?.name?.toString() ?? "";
  email.value = route.query?.email?.toString() ?? "";
  phone.value = route.query?.phone?.toString() ?? "";
  parseComplete.value = true;
};

onMounted(() => {
  parseLoginId();
});

const __returned__ = { route, parseComplete, serviceStore, twcConfig, loginId, name, email, phone, chatUrl, parseLoginId, NavigationBar, Page }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})